import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  divItems: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  formControl: {
    marginRight: 0,
    marginLeft: 0,
    marginTop: 10,
    marginBottom: 10,
    minWidth: 120,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    bottom: '0',
    right: '0',
    width: '100%',
    marginRight: '16px',
    paddingBottom: '4px',
    zIndex: 1,
    background: 'white',
  },
  button: {
    margin: '4px',
  },
  fullWidth: {
    width: '100%',
  },
  scrollY: {
    overflowY: 'auto',
  },
  paddingBottom: {
    paddingBottom: '48px',
  },
  containerDialogTitle: {
    padding: '0',
  },
}));

export default styles;
